import apiClient from "./axios"

export const getReminders = async (params = {}) => {
  const { data } = await apiClient.get("/reminders", { params })
  return data
}

export const getReminderMeta = async () => {
  const { data } = await apiClient.get("/reminders/meta")
  return data
}

export const getReminder = async id => {
  const { data } = await apiClient.get(`/reminders/${id}`)
  return data
}

export const createReminder = async payload => {
  const { data } = await apiClient.post("/reminders", payload)
  return data
}

export const editReminder = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/reminders/${id}`, payload)
  return data
}

export const deleteReminder = async id => {
  const { data } = await apiClient.delete(`/reminders/${id}`)
  return data
}
